import { App } from "antd"
import {
  useState
} from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Container, FullRow, NormalText, RowButton, RowInput, Title } from "../../components"
import { decodeHttpSafe, hashPassword, sha256 } from "../../config"
import { resetPassword } from "../../endpoints"



//https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do



export function ResetPassword(): JSX.Element {
  const [password, setPassword] = useState("")
  const [password2, setPassword2] = useState("")
  const{modal}=App.useApp()
  const [searchParams] = useSearchParams()
  const e=searchParams.get('e')??""
  const i=searchParams.get('i')??""
  const c=searchParams.get('c')??""
  const params=JSON.parse(decodeHttpSafe(c))


  const navigate = useNavigate()
  
  const handleSubmit = async () => {
   
    if (password !== password2) {
      modal.warning({
        title: "warning",
        content: "The passwords do not match, please retype",
      })
      return
    }

    if (!password) {
      modal.warning({ title: "warning", content: "Password cannot be empty" })
      return
    }
    if (!params.email) {
      modal.warning({ title: "warning", content: "Email cannot be empty" })
      return
    }

    if (params.email.length > 0 && password.length > 0) {
      // const hash = CryptoJS.SHA256(password).toString()
      const hash=await hashPassword(await sha256( password+'plab'))
      console.log('register hash',hash)      

      const res = await resetPassword({
        encrypt:e,
        iv:i,
        userId:params.id, 
        password:hash
      })
      // consolelog('res',res)
      if (res.code === 1000) {
        // refreshUser?.({ user: res.user ?? "Login" });
        // success({ content: "Password successfully changed." })
        navigate(res.message)
      } else {
        modal.warning({ content: res.message })
      }
    }
  }

  return (
    <Container>
      <FullRow>
        <Title>Reset Password</Title>
      </FullRow>
      <FullRow>
        <NormalText>Email: {params.email}</NormalText>
      </FullRow>
      <FullRow>
        <RowInput
          placeholder="New Password"
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          name="password"
          maxLength={40}
        />
      </FullRow>
      <FullRow>
        <RowInput
          placeholder="Retype password"
          type="password"
          id="password2"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          name="password2"
          maxLength={40}
        />
      </FullRow>
      <FullRow>
        <RowButton type="primary" onClick={handleSubmit} id="submit">
          Submit
        </RowButton>
      </FullRow>
    </Container>
  )
}
